import React from "react";
import Hero from "./Hero";
import About from "./About";
import Skills from "./Skills";
import PortfolioHighlights from "./PortfolioHighlights";
import Achievements from "./Achievements";
import ContactMe from "./ContactMe";
import Footer from "./Footer";

const Body = () => {
  return (
    <div className="w-full flex flex-col">
      <Hero />
      <About />
      <Skills />
      <PortfolioHighlights />
      <Achievements />
      <ContactMe />
      <Footer />
    </div>
  );
};

export default Body;
